import type { FC } from 'react';
import type { Order } from '../types';
import StatusBadge from './StatusBadge';
import OrderTypeBadge from './OrderTypeBadge.tsx';

const formatDate = (d?: string | null) => (d ? new Date(d).toLocaleString() : '–');

interface OrderRowProps {
    order: Order;
    onRowClick: (id: string | number) => void;
    onAssign: (order: Order) => void;
}

// Shared row for "orders needing a driver" style tables: Ref / Customer / Type /
// Status / Created / Assign action. Row click navigates to the order detail page;
// the Assign button stops propagation to open the assign modal instead.
const OrderRow: FC<OrderRowProps> = ({ order, onRowClick, onAssign }) => (
    <tr key={order.id} onClick={() => onRowClick(order.id)}
        className="cursor-pointer hover:bg-stone-50 transition">
        <td className="px-4 py-3 font-medium text-stone-900">{order.reference}</td>
        <td className="px-4 py-3 text-stone-700">
            {order.customer?.first_name} {order.customer?.last_name}
        </td>
        <td className="px-4 py-3">
            <OrderTypeBadge type={order.type} />
        </td>
        <td className="px-4 py-3"><StatusBadge status={order.status ?? ''} /></td>
        <td className="px-4 py-3 text-stone-500 text-xs">{formatDate(order.created_at)}</td>
        <td className="px-4 py-3 text-right">
            <button onClick={e => { e.stopPropagation(); onAssign(order); }}
                    className="px-3 py-1.5 bg-stone-900 text-white text-xs rounded-full hover:bg-stone-700 transition">
                Assign
            </button>
        </td>
    </tr>
);

export default OrderRow;